import { PageTransitionButtonContainer, PageTransitionContainer } from 'components/animations';
import { AppBar, Body, Button, PageLayout } from 'components/common';
import { usePageTransition } from 'hooks/animations';
import useUnderage from 'hooks/useUnderage';
import React, { useEffect } from 'react';

const PageUnderAgePicturePreview: React.FC = () => {
  const { idCardFile, capturedFile, setIdCardFile } = useUnderage();
  const animation = usePageTransition();

  useEffect(() => {
    return () => {
      window.FaceDetector.setFaceDetect(0, false, () => {});
    };
  }, []);

  const handleSubmit = () => {
    if (!capturedFile || !idCardFile) {
      const hMainContainer = document.getElementById('hMainContainer');
      if (hMainContainer) {
        CommonUI.showToast(hMainContainer, { text: brsc.try_later, duration: 2000, position: 'top' });
      }
      return;
    }

    Transition.showPage(Def.PAGE_UNDERAGE_COMPLETE);
  };

  const handleRetake = () => {
    // 비우지 않으면 Form 이 idCardFile 존재를 보고 다시 미리보기로 점프해 재촬영이 불가능해진다.
    setIdCardFile(null);
    Transition.showPage(Def.PAGE_UNDERAGE_FORM);
  };

  return (
    <PageLayout>
      <AppBar title={brsc.age_verification_btn} onBack={handleRetake} />
      <Body className="flex flex-col pb-[120px]">
        <PageTransitionContainer isVisible={animation.contentVisible} className="flex flex-1 items-center justify-center px-6">
          {idCardFile && (
            <div className="w-full max-w-sm overflow-hidden rounded-lg bg-white">
              <img src={idCardFile.base64} alt="ID Card" className="h-auto w-full rounded-lg object-contain" />
            </div>
          )}
        </PageTransitionContainer>

        <PageTransitionButtonContainer isVisible={animation.buttonVisible}>
          <Button
            style={{
              text: brsc.confirm,
              color: 'btn-bg-primary',
              fontColor: 'white',
            }}
            onClick={handleSubmit}
            className="flex-1"
          />
        </PageTransitionButtonContainer>
      </Body>
    </PageLayout>
  );
};

export default PageUnderAgePicturePreview;
